import * as THREE from 'three';

const MAX_PIXEL_RATIO = 2;

export function initializeRenderer(
  canvas: HTMLCanvasElement,
  parent: HTMLElement,
): THREE.WebGLRenderer {
  const renderer = new THREE.WebGLRenderer({
    canvas,
    antialias: true,
  });
  renderer.setSize(parent.clientWidth, parent.clientHeight);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, MAX_PIXEL_RATIO));
  return renderer;
}
